import { MiniaturaDeLayout } from '@/features/documentos/components/MiniaturaDeLayout';
import { DESCRICAO_MODELO, MODELOS, ROTULO_MODELO, type Modelo } from '@/features/documentos/rotulos';
import { cn } from '@/shared/lib/cn';

/**
 * Os cinco papéis, em grade.
 *
 * Mesma técnica do seletor de fonte de assinatura (`AssinaturaCard`): botões
 * com `aria-pressed` e amostra ao vivo dentro, em vez de um `<Select>`. Escolher
 * aparência por lista de texto obrigaria a decorar o que cada nome significa.
 *
 * O `aria-label` existe pelo mesmo motivo de lá: sem ele, o nome acessível do
 * botão viraria a miniatura inteira, e o leitor de tela não teria o que ler.
 */
export function SeletorDeModelo({
  modelo,
  cor,
  aoEscolher,
}: {
  modelo: Modelo;
  cor: string;
  aoEscolher: (modelo: Modelo) => void;
}) {
  return (
    <div className="space-y-2">
      <p className="text-sm font-medium text-brand">Modelo</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2">
        {MODELOS.map((m) => (
          <button
            key={m}
            type="button"
            aria-label={`Modelo ${ROTULO_MODELO[m]}`}
            aria-pressed={modelo === m}
            onClick={() => aoEscolher(m)}
            className={cn(
              'p-2 rounded-lg border-2 text-left transition-all',
              modelo === m ? 'border-brand bg-brand/5' : 'border-border hover:border-brand/40',
            )}
          >
            <MiniaturaDeLayout modelo={m} cor={cor} />
            <span className="text-xs font-medium text-foreground mt-1.5 block truncate">
              {ROTULO_MODELO[m]}
            </span>
            <span className="text-[10px] text-muted-foreground block leading-tight">
              {DESCRICAO_MODELO[m]}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
